import React from 'react'

import Icon from '@/components/common/Icon'

const IconRocketship: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width, height }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_959_2602"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_959_2602)">
      <path
        d="M5.6498 10.025L7.5998 10.85C7.83314 10.3833 8.0748 9.93333 8.3248 9.5C8.5748 9.06667 8.8498 8.63333 9.1498 8.2L7.7498 7.925L5.6498 10.025ZM9.1998 12.1L12.0498 14.925C12.7498 14.6583 13.4998 14.25 14.2998 13.7C15.0998 13.15 15.8498 12.525 16.5498 11.825C17.7165 10.6583 18.629 9.3625 19.2873 7.9375C19.9456 6.5125 20.2331 5.2 20.1498 4C18.9498 3.91667 17.6331 4.20417 16.1998 4.8625C14.7665 5.52083 13.4665 6.43333 12.2998 7.6C11.5998 8.3 10.9748 9.05 10.4248 9.85C9.8748 10.65 9.46647 11.4 9.1998 12.1ZM13.6498 10.475C13.2665 10.0917 13.0748 9.62083 13.0748 9.0625C13.0748 8.50417 13.2665 8.03333 13.6498 7.65C14.0331 7.26667 14.5081 7.075 15.0748 7.075C15.6415 7.075 16.1165 7.26667 16.4998 7.65C16.8831 8.03333 17.0748 8.50417 17.0748 9.0625C17.0748 9.62083 16.8831 10.0917 16.4998 10.475C16.1165 10.8583 15.6415 11.05 15.0748 11.05C14.5081 11.05 14.0331 10.8583 13.6498 10.475ZM14.1248 18.5L16.2248 16.4L15.9498 15C15.5165 15.3 15.0831 15.5708 14.6498 15.8125C14.2165 16.0542 13.7665 16.2917 13.2998 16.525L14.1248 18.5ZM21.9498 2.175C22.2665 4.19167 22.0706 6.15417 21.3623 8.0625C20.654 9.97083 19.4331 11.7917 17.6998 13.525L18.1998 16C18.2665 16.3333 18.2498 16.6583 18.1498 16.975C18.0498 17.2917 17.8831 17.5667 17.6498 17.8L13.4498 22L11.3498 17.075L7.0748 12.8L2.1498 10.7L6.3248 6.5C6.55814 6.26667 6.83731 6.1 7.1623 6C7.4873 5.9 7.81647 5.88333 8.1498 5.95L10.6248 6.45C12.3581 4.71667 14.1748 3.49167 16.0748 2.775C17.9748 2.05833 19.9331 1.85833 21.9498 2.175ZM3.9248 15.975C4.50814 15.3917 5.22064 15.0958 6.0623 15.0875C6.90397 15.0792 7.61647 15.3667 8.1998 15.95C8.78314 16.5333 9.07064 17.2458 9.0623 18.0875C9.05397 18.9292 8.75814 19.6417 8.1748 20.225C7.75814 20.6417 7.0623 21 6.0873 21.3C5.1123 21.6 3.76647 21.8667 2.0498 22.1C2.28314 20.3833 2.5498 19.0375 2.8498 18.0625C3.1498 17.0875 3.50814 16.3917 3.9248 15.975ZM5.3498 17.375C5.18314 17.5417 5.01647 17.8458 4.8498 18.2875C4.68314 18.7292 4.56647 19.175 4.4998 19.625C4.9498 19.5583 5.39564 19.4458 5.8373 19.2875C6.27897 19.1292 6.58314 18.9667 6.7498 18.8C6.9498 18.6 7.05814 18.3583 7.0748 18.075C7.09147 17.7917 6.9998 17.55 6.7998 17.35C6.5998 17.15 6.35814 17.0542 6.0748 17.0625C5.79147 17.0708 5.5498 17.175 5.3498 17.375Z"
        fill="#277C09"
      />
    </g>
  </svg>
)

export default Icon(IconRocketship)
